import styles from './Loader.module.scss';
import { FC } from 'react';

const Loader: FC = () => {
  return <div className={styles.Loader}></div>;
};
export default Loader;
